module.exports = __webpack_public_path__ + "img/18.077b1973.jpg";